module.exports = __webpack_public_path__ + "static/media/icon-golfbag.172bab5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-golfbag.svg
// module id = 989
// module chunks = 0